import React, { useEffect, useState } from 'react';
import { Table, Button } from 'reactstrap';
import { toast } from 'react-toastify';
import { Link, useHistory } from 'react-router-dom';
import EditOutlineIcon from 'mdi-react/EditOutlineIcon';
import DeleteOutlineIcon from 'mdi-react/DeleteOutlineIcon';
import BellOutlineIcon from 'mdi-react/BellOutlineIcon';
import Api from '../../util/api';
import t, { partial } from '../../util/translation/translation';
import useModal from '../../shared/hooks/useModal';
import DeleteModal from '../../shared/components/custom/DeleteModal';
import Loading from '../../shared/components/custom/Loading';
import FormCard from '../../shared/components/custom/FormCard';
import SquareIconButton from '../../shared/components/custom/SquareIconButton';

const NotificationLabelPage = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [labels, setLabels] = useState([]);
  const [handleModal, visible, deleteID] = useModal();
  const s = partial('shared');
  const p = partial('MessagesPage');

  const getLabels = async () => {
    setLoading(true);
    try {
      const labelResponse = await Api.userDevices.getAllNotificationLabels();
      setLabels(labelResponse || []);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error(t('api.404'));
    }
  };
  useEffect(() => {
    getLabels();
  }, []);
  const renderLabels = () =>
    labels.map((label) => (
      <tr key={`label-${label.id}`}>
        <td className="table-stack__primary">
          <Link
            to={`/notification_label/edit/${label.id}`}
            className="font-weight-500"
          >
            {label.title}
          </Link>
        </td>
        <td data-label={p('approvalsCount')}>
          {label.approvalsCount != null ? (
            <span className="qb-chip label-approvals">
              <BellOutlineIcon size={14} />
              {label.approvalsCount.toLocaleString()}
            </span>
          ) : (
            <span className="text-muted">–</span>
          )}
        </td>
        <td className="table-stack__actions">
          <div className="icon-actions justify-content-end">
            <SquareIconButton
              icon={<EditOutlineIcon />}
              title={s('edit')}
              id={`edit-label-${label.id}`}
              onClick={() =>
                history.push(`/notification_label/edit/${label.id}`)
              }
            />
            <SquareIconButton
              icon={<DeleteOutlineIcon />}
              title={s('delete')}
              tone="danger"
              id={`delete-label-${label.id}`}
              onClick={() => handleModal(label.id)}
            />
          </div>
        </td>
      </tr>
    ));
  const deleteNotificationLabel = async () => {
    setLoading(true);
    try {
      await Api.userDevices.deleteNotificationLabel(deleteID);
      toast.success(s('deleteSuccessful'));
    } catch (err) {
      toast.error(t('api.404'));
    } finally {
      handleModal();
      getLabels();
    }
  };
  return (
    <>
      <Loading loading={loading} />
      <DeleteModal
        visible={visible}
        type={p('notificationLabel').toLowerCase()}
        handleModal={handleModal}
        modalAction={deleteNotificationLabel}
      />
      <FormCard
        title={
          <>
            {p('notificationLabels')}
            <span className="form-card__count">{labels.length}</span>
          </>
        }
        actions={
          <Link to="/notification_label/create">
            <Button color="primary" size="sm" className="mb-0">
              {p('createLabel')}
            </Button>
          </Link>
        }
        bodyClassName="form-card__body--flush"
        className="messages-settings__labels"
      >
        <p className="form-card__intro">{p('notificationLabelsHint')}</p>
        <Table responsive striped className="table--roomy table--stack mb-0">
          <thead>
            <tr>
              <th>{s('title')}</th>
              <th>{p('approvalsCount')}</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {renderLabels()}
            {!loading && !labels.length && (
              <tr>
                <td colSpan={3} className="settings-empty">
                  {p('noNotificationLabels')}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </FormCard>
    </>
  );
};

export default NotificationLabelPage;
